/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import CloseIcon from "@mui/icons-material/Close";
import {
    Box,
    Button,
    Chip,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useForm } from "src/shared/hooks/useForm";
import { selectMainState, useSelector } from "src/stateManagement/redux";
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import { StatusConditions, TypesOfActivities } from "src/stateManagement/redux/slices/shared/interfaces";
import EditIcon from '@mui/icons-material/Edit';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

interface Props {
    TabDisable: boolean;
    open: boolean;
    setOpen: any;
    requirements: any[];
    setRequeriments: any;
}

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    gap: 2,
    p: 4,
};

export const Requirements = ({
    TabDisable,
    setOpen,
    open,
    requirements,
    setRequeriments,
}: Props) => {
    const { locationName, lastStatusConditions, optimizationRequirements: currentRequirements } = useSelector((state: any) => state.location);

    const { configModules } = useSelector(selectMainState);

    const [typesActivities, setTypesActivities] = useState<TypesOfActivities[]>([])

    const [statusConditions, setStatusConditions] = useState<StatusConditions[]>([])

    const [optimizationActivitiesStates, setOptimizationActivitiesStates] = useState<any[]>([])

    const [formValues, handleInputChange, reset, setNuewValues] = useForm({
        type: "",
        comments: "",
        status: "pending",
        simulationDate: undefined,
        targetProduction: undefined,
        lastProduction: undefined
    });

    const [listActiveBloquers, setlistActiveBloquers] = useState<any>([])

    useEffect(() => {

        if (Array.isArray(configModules?.typesActivitiesForOptimization)) {
            setTypesActivities(configModules?.typesActivitiesForOptimization)
        }
        if (Array.isArray(configModules?.statusConditions)) {
            setStatusConditions(configModules?.statusConditions)
        }

        if (Array.isArray(configModules?.optimizationActivitiesStates)) {

            const filtedStates = configModules?.optimizationActivitiesStates?.filter((state: any) => state?.type?.includes("Requirement"))

            setOptimizationActivitiesStates(filtedStates)
        }

    }, [configModules])

    useEffect(() => {

        const blockers = []

        const typeActivity = typesActivities.find(
            (activity: any) => activity.label === formValues.type
        );
        const values: any = { ...lastStatusConditions }

        for (const blocker of typeActivity?.deppendOf || []) {
            const statusBlocker = statusConditions.find(
                (status: any) => status.field === blocker
            )?.warningStatus;

            if (statusBlocker?.includes(values[blocker])) {
                blockers.push(blocker)
            }
        }

        setlistActiveBloquers(blockers)
    }, [formValues])

    const { type, comments, status, simulationDate, targetProduction, lastProduction } = formValues;

    const columns: GridColDef[] = [
        { field: "location", headerName: "Locación", flex: 1 },
        {
            field: "name",
            headerName: "Requerimiento",
            flex: 1,
        },
        { field: "comments", headerName: "Comentario", flex: 1 },
        {
            field: "actions",
            headerName: "",
            width: 100,

            renderCell: (params) => {
                return (
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                        <IconButton
                            color="error"
                            onClick={() => handleDeleteRequirement(params.row.id)}
                            size="small"
                        >
                            <DeleteIcon />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleEditRow(params.row)}
                        >
                            <EditIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                );
            },
        },
    ];

    const paginationModel = { page: 0, pageSize: 10 };

    const handleClose = () => {
        setOpen(false)
        reset();
    };

    const handleAddRequirement = () => {
        const element = typesActivities.find(
            (activity: any) => activity.label === type
        );

        const blocker = listActiveBloquers?.map((blocker: any, index: number) => {
            const values: any = { ...lastStatusConditions }
            const statusBlocker = statusConditions.find(
                (status: any) => status.field === blocker
            );

            return { [String(statusBlocker?.name)]: values[blocker] }
        })

        const data = {
            id: element?.id,
            location: locationName,
            name: type,
            value: "Si",
            type: "Optimization",
            comments,
            blocker,
            status,
            simulationDate,
            targetProduction,
            lastProduction,
        };

        if (blocker?.length > 0) {
            Swal.fire({
                title: "Existen bloqueantes para esta actividad, no puede ser programada continuar.",
                text: "",
                icon: "error",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Entendido",
                customClass: {
                    title: "sweat_alert_title"
                }
            });
            return;
        }

        const otherRequirements = requirements.filter(r => r.name !== type)

        setRequeriments([data, ...otherRequirements]);
        reset();
        setOpen(false);
    };

    const handleDeleteRequirement = (id: string) => {
        const newRequirements = requirements.filter(
            (requirement: any) => requirement.id !== id
        );
        setRequeriments(newRequirements);
    };

    const handleEditRow = (row: any) => {
        setNuewValues({
            type: row.name,
            comments: row.comments,
            status: row.status,
            simulationDate: row.simulationDate,
            targetProduction: row.targetProduction,
            lastProduction: row.lastProduction
        })
        setOpen(true);
    }

    return (
        <Grid container spacing={0}>
            {/* table */}
            <Grid size={12}>
                <DataGrid
                    rows={requirements}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{
                        border: 0,
                        mt: 2,
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "#316EBC",
                            color: "#fff",
                            fontWeight: "bold",
                        },
                    }}
                    getRowId={(row) => row.id}
                />
            </Grid>
            {/* Modal */}
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    {/* Modal header button */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mb: 2,
                        }}
                    >
                        <IconButton
                            aria-label="delete"
                            onClick={handleClose}
                            sx={{
                                backgroundColor: "#cf1919",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#ff3535",
                                },
                                width: 30,
                                height: 30,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Grid sx={{ padding: 1 }}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">
                                Tipo de Actividad
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                label="Tipo de Actividad"
                                id="demo-simple-select"
                                name="type"
                                value={type}
                                onChange={handleInputChange}
                                size="small"
                            >
                                {/* <MenuItem value=""></MenuItem> */}
                                {typesActivities.map((activity: any, index) => {

                                    const exist = currentRequirements.find(
                                        (requirement: any) => requirement.variableId === activity.id && requirement.status === "pending"
                                    );
                                    return (
                                        <MenuItem
                                            value={activity.label}
                                            key={index}
                                            disabled={exist ? true : false}
                                            sx={{
                                                display: `${requirements.find(
                                                    (requirement) =>
                                                        requirement.name ===
                                                        activity.label
                                                )
                                                    ? "none"
                                                    : "block"
                                                    }`,
                                            }}
                                        >
                                            {activity.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid sx={{ padding: 1 }}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">
                                Estado
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                label="Tipo de Actividad"
                                id="demo-simple-select"
                                name="status"
                                value={status}
                                onChange={handleInputChange}
                                size="small"
                            >
                                {/* <MenuItem value=""></MenuItem> */}
                                {optimizationActivitiesStates.map((state: any, index) => {
                                    return (
                                        <MenuItem
                                            value={state.id}
                                            key={index}
                                        >
                                            {state.name}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid sx={{ padding: 1, display: "flex", alignItems: "center" }}>
                        <DesktopDatePicker
                            defaultValue={null}
                            label="Fecha Simulación"
                            name="simulationDate"
                            value={simulationDate ? moment(simulationDate) : null}
                            onChange={(event) => {
                                const formattedDate = moment(event).format("YYYY-MM-DD");
                                handleInputChange({
                                    target: {
                                        name: "simulationDate",
                                        value: formattedDate,
                                    }
                                });
                            }}
                            sx={{
                                width: "100%",
                            }}
                        />
                        <IconButton
                            size="small"
                            color="warning"
                            disabled={!simulationDate}
                            onClick={() => {
                                handleInputChange({
                                    target: {
                                        name: "simulationDate",
                                        value: null,
                                    }
                                });
                            }}
                        >
                            <RemoveCircleIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                    <Grid sx={{ padding: 1 }}>
                        <TextField
                            fullWidth
                            size="medium"
                            name="targetProduction"
                            label="Ultima Medida BBPD"
                            value={targetProduction || 0}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleInputChange({
                                    target: {
                                        name: "targetProduction",
                                        value: numericValue,
                                    }
                                });
                            }}
                        />
                    </Grid>
                    <Grid sx={{ padding: 1 }}>
                        <TextField
                            fullWidth
                            size="medium"
                            name="lastProduction"
                            label="Ganancial Estimado BBPD"
                            value={lastProduction || 0}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleInputChange({
                                    target: {
                                        name: "lastProduction",
                                        value: numericValue,
                                    }
                                });
                            }}
                        />
                    </Grid>
                    <TextField
                        fullWidth
                        size="small"
                        label="Comentario"
                        multiline
                        rows={4}
                        sx={{ mt: 2 }}
                        value={comments}
                        name="comments"
                        onChange={handleInputChange}
                    />
                    {/* save button */}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="small"
                        sx={{ mt: 2 }}
                        onClick={handleAddRequirement}
                    >
                        Agregar
                    </Button>
                </Box>
            </Modal>
        </Grid>
    );
};
